<div ngbDropdown container="body" class="dropdown" *transloco="let t" [class.primary]="primary">
  <button
    class="btn dropdown-toggle d-inline-flex align-items-center justify-content-center p-0"
    type="button"
    id="dropdown-action-button"
    ngbDropdownToggle
    (click)="$event.stopPropagation()"
  >
    <i class="material-symbols-rounded dots-icon"> more_horiz </i>
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdown-action-button" ngbDropdownMenu>
    <button
      ngbDropdownItem
      class="dropdown-item d-flex align-items-center gap-3"
      type="button"
      *ngFor="let item of actionItems"
      (click)="action.emit(item)"
    >
      <isophi-print-download-icon *ngIf="item.icon === printDownloadIcon; else symbol" class="text-black-50 fs-20"></isophi-print-download-icon>
      <ng-template #symbol>
        <span class="material-symbols-rounded text-black-50 fs-20">
          {{ item.icon }}
        </span>
      </ng-template>
      {{ item.label }}
    </button>
  </div>
</div>
